import React, { Component } from "react";

import digitalQuestions from "../digital-questions";



import {
  Route,
  Redirect,
  Switch,
  BrowserRouter as Router
} from "react-router-dom";
import DCGQuestions from "../modules/dcg_questions";
import DailySummary from "../modules/daily_summary";
import AssociateComparison from "../modules/associate_comparison";
import StoreComparison from "../modules/store_comparison";
import MarketComparison from "../modules/market_comparison";
import login from '../modules/login'
import UnAuthUser from "../modules/unauthuser";
import DcgViewerPdf from "../modules/dcg_viewer_pdf";
import Faq from "../modules/faq";
import EmailCount from "../modules/email_count_summary";
import StatusReport from "../modules/status_report";
import FaqList from "../modules/faq/faqlist";
import DesignStatusReport from "../modules/design_status_report";



class Routing extends Component {
  constructor(props) {
    super(props);
  }
  render() {
    return (
      <Router>
        <Switch>
          {/* Route definitions */}
          <Route path="/login" component={login} />
          {/* <Route path="/digital-questions" component={digitalQuestions} /> */}
          <Route path="/dcg-questions" component={DCGQuestions} />
          <Route path="/daily-summary" component={DailySummary} />
          <Route path="/associate-comparison" component={AssociateComparison} />
          <Route path="/store-comparison" component={StoreComparison} />
          <Route path="/market-comparison" component={MarketComparison} />
          <Route path="/unauth" component={UnAuthUser} />

          <Route path="/status-report" component={StatusReport} />
          <Route path="/emailclick-summary" component={EmailCount} />
          <Route path="/dcg-viewer" component={DcgViewerPdf} />
          <Route path="/faq" component={Faq} />
          <Route path="/faq-list" component={FaqList} />
          <Route path="/design-status-report" component={DesignStatusReport} />
          <Route path="/" component={login} />
          

        </Switch>
      </Router>
    );
  }
}
export default Routing;
